export default __webpack_public_path__ + "static/media/cljs.55e58ba3.svg";